var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-button",class:{ 'loading': _vm.loading },attrs:{"disabled":_vm.loading},on:{"click":_vm.handleClick}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.buttonText))]):_c('span',[_vm._v("加载中...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }